<template>
  <div class="main">
    <GoBack :name="`每日任务`" :type="1" :path="`/mobile/home`"></GoBack>
    <!-- //阴影 -->
    <img class="bg2" src="@/assets/mobile/image/home/bg2.png" />

    <div class="jinbi">
      <div class="box">
        <div class="number">{{ userInfo.balance }}</div>
        <div class="name">我的金币余额</div>
      </div>
      <div class="box">
        <img src="@/assets/mobile/image/home/jinbi.png" />
      </div>
    </div>

    <div class="content-box">
      <div class="title">新手任务</div>
      <div class="box-item" v-for="item in list1" :key="item.name">
        <div class="left">
          <img :src="item.url" />
          <div class="name-box">
            <div class="name">{{ item.name }}</div>
            <div class="title2">{{ item.title }}</div>
          </div>
        </div>
        <div class="right">
          <div class="wanc wancc" v-if="item.type">已完成</div>
          <div class="wanc" v-else @click="goUrl(item.path)">去完成</div>
        </div>
      </div>
      <div class="title title-top">日常任务</div>
      <div class="box-item" v-for="item in list2" :key="item.name">
        <div class="left">
          <img :src="item.url" />
          <div class="name-box">
            <div class="name">{{ item.name }}</div>
            <div class="title2">{{ item.title }}</div>
          </div>
        </div>
        <div class="right">
          <div class="wanc wancc" v-if="item.type">已完成</div>
          <div class="wanc" v-else @click="goUrl(item.path)">去完成</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import GoBack from "@/components/goBack";
import { getAccount, getProfile, getSigned } from "@/api/mobile";
export default {
  data() {
    return {
      list1: [
        {
          name: "完善个人信息",
          title: "可获得10金币",
          url: require("@/assets/mobile/image/home/xsrw1.png"),
          type: false,
          path: "/mobile/personalData",
        },
        {
          name: "完成新手问卷",
          title: "可获得10金币",
          url: require("@/assets/mobile/image/home/xsrw2.png"),
          type: false,
          path: "/mobile/task",
        },
      ],
      list2: [
        {
          name: "每日签到",
          title: "可获得10金币",
          url: require("@/assets/mobile/image/home/rcrw1.png"),
          type: false,
          path: "/mobile/signIn",
        },
        {
          name: "成功邀请好友并注册",
          title: "可获得10金币",
          url: require("@/assets/mobile/image/home/rcrw2.png"),
          type: false,
          path: "/mobile/invite",
        },
        // {
        //   name: "浏览公众号",
        //   title: "可获得10金币",
        //   url: require("@/assets/mobile/image/home/rcrw3.png"),
        //   type: 2,
        // },
        {
          name: "参与调研问卷",
          title: "可获得10金币",
          url: require("@/assets/mobile/image/home/rcrw4.png"),
          type: false,
          path: "/mobile/task",
        },
      ],
      userInfo: {},
    };
  },
  components: { GoBack },
  methods: {
    goUrl(path) {
      this.$router.push(path);
    },
    isAllNotNull(obj) {
      // 获取对象的所有自身可枚举属性名，并使用 every 遍历判断
      return Object.keys(obj).every((key) => obj[key] !== null);
    },

    async getProfile() {
      await getProfile().then((res) => {
        if (res.code) {
          const profileInfo = {
            name: res.data.name || null,
            gender: res.data.gender || null,
            birthday: res.data.birthday || null,
            provinceId: res.data.provinceId || null,
            cityId: res.data.cityId || null,
            districtId: res.data.districtId || null,
          };
          this.list1[0].type = this.isAllNotNull(profileInfo);
        }
      });
    },
    //今日是否签到
    async getSigned() {
      await getSigned().then((res) => {
        if (res.code === 200) {
          this.list2[0].type = res.data.signed;
        }
      });
    },
  },
  async created() {
    await getAccount().then((res) => {
      if (res.code === 200) {
        this.userInfo = res.data;
        this.$store.commit("changeUserInfo", this.userInfo);
        localStorage.setItem("userInfo", JSON.stringify(res.data));
      }
    });

    await this.getProfile();
    await this.getSigned();
  },
};
</script>
<style lang="scss" scoped>
.main {
  position: relative;
  width: 100%;
  min-height: 100vh;
  background-color: #f7f7f7;
  .bg2 {
    position: absolute;
    width: 100%;
    top: 0;
    z-index: 0;
  }
  .jinbi {
    width: calc(100% - 60px);
    height: 109px;
    background: RGBA(255, 255, 255, 0.5);
    border-radius: 8px 8px 8px 8px;
    border: 0.5px solid #ffffff;
    position: relative;
    z-index: 2;
    left: 50%;
    transform: translateX(-50%);
    margin-top: 41px;
    display: flex;
    justify-content: space-between;
    .box {
      display: flex;
      flex-direction: column;
      margin-left: 17px;
      margin-right: 49px;
      align-items: center;
      .number {
        color: #ffffff;
        font-size: 27px;
        font-weight: bolder;
        margin-top: 12px;
      }
      .name {
        color: #ffffff;
        font-size: 14px;
        margin-top: 3px;
      }
      img {
        width: 30px;
        height: 30px;
        margin-top: 31px;
      }
    }
  }
  .content-box {
    width: calc(100% - 30px);
    background: #ffffff;
    border-radius: 4px 4px 4px 4px;
    margin-left: 15px;
    position: absolute;
    z-index: 2;
    top: 165px;
    padding: 10px;
    box-sizing: border-box;
    padding-bottom: 100px;
    .title {
      color: #232323;
      font-size: 16px;
      font-weight: bolder;
      margin-top: 9px;
    }
    .title-top {
      margin-top: 29px;
    }
    .box-item {
      display: flex;
      justify-content: space-between;
      margin-top: 20px;
      align-items: center;
      .left {
        display: flex;
        img {
          width: 40px;
          height: 40px;
          margin-right: 15px;
        }
        .name-box {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          .name {
            font-size: 14px;
            color: #232323;
            font-weight: bolder;
          }
          .title2 {
            font-size: 12px;
            color: #666666;
          }
        }
      }
      .right {
        .wanc {
          width: 57px;
          height: 24px;
          background: rgba(136, 70, 255, 0.05);
          border-radius: 12px 12px 12px 12px;
          line-height: 24px;
          text-align: center;
          font-size: 12px;
          color: #8846ff;
        }
        .wancc {
          background: #f0f0f0;
          color: #999999;
        }
      }
    }
  }
}
</style>